class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.menuItem = this.querySelectorAll('[data-menu-data-push]');
    this.headerWrapper = this.closest('.shopify-section-group-header-group');
    this.templateType = document.querySelector('[data-template-class]').dataset.templateClass;
    this.icon = document.querySelectorAll('.icon-list__item');

    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this));
    }

    this.pageURL = window.location.href != '' ? window.location.href : 'undefined';
    this.pageType = this.templateType != '' ? this.templateType : 'undefined';

    this.getHoveredMenuItems();
    this.getClickedMenuItems();
    this.getClickedIcon();
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    if (this.headerWrapper) {
      document.body.classList.add('header-is-open');
    }
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    if (this.headerWrapper) {
      document.body.classList.remove('header-is-open');
    }
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
    if (this.headerWrapper) {
      document.body.classList.add('header-is-open');
    }
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
    if (this.headerWrapper) {
      document.body.classList.remove('header-is-open');
    }
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      document.body.classList.add('header-is-open');
      this.inverse && this.header.classList.add('header-inverse-solid');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        document.body.classList.remove('header-is-open');
        this.inverse && document.body.classList.remove('header-inverse-solid');
      }
    }
  }

  // Get the data for the open and close of the header
  getHoveredMenuItems() {
    this.menuItem.forEach((item) => {
      // Function to handle the event for opening
      const handleOpenEvent = (event) => {
        let menuItemText = '';

        if (event.currentTarget.hasAttribute('data-input-value')) {
          menuItemText = event.currentTarget.getAttribute('data-input-value').trim();
        } else {
          const childWithDataAttributeValue =
            event.currentTarget.querySelector('[data-input-value]');
          if (childWithDataAttributeValue) {
            menuItemText = childWithDataAttributeValue.getAttribute('data-input-value').trim();
          }
        }

        if (menuItemText) {
          this.lastHoveredMenuItem = menuItemText; // Track the last hovered menu item
          this.pushDataLayerOnOpen(menuItemText);
        } else {
          debug() && console.log('Menu item text not found');
        }
      };

      // Function to handle the event for closing
      const handleCloseEvent = (event) => {
        if (this.lastHoveredMenuItem) {
          this.pushDataLayerOnClose(this.lastHoveredMenuItem);
          this.lastHoveredMenuItem = ''; // Reset the last hovered menu item
        }
      };

      // Listen for mouseenter and click events for opening
      item.addEventListener('mouseenter', handleOpenEvent);
      item.addEventListener('click', handleOpenEvent);

      // Listen for mouseleave event for closing
      item.addEventListener('mouseleave', handleCloseEvent);
    });
  }

  // Function to get the data of the clicked menu item
  getClickedMenuItems() {
    const submenuItems = document.querySelectorAll('.header__menu-link.level-2');

    submenuItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        // Use an arrow function here
        const clickTitle = event.target.textContent.trim();

        const navigationItem = event.target.closest('.header__menu-item.level-1');
        let navigationTitle = '';
        if (navigationItem) {
          const navigationLink = navigationItem.querySelector('.header__menu-link.level-1');
          if (navigationLink) {
            navigationTitle = navigationLink.textContent.trim();
          }
        }

        if (navigationTitle && clickTitle) {
          this.pushDataLayerOnClick(navigationTitle, clickTitle);
        }
      });
    });
  }

  // When header icon is clicked push to data layer
  getClickedIcon() {
    this.icon.forEach((item) => {
      item.addEventListener('click', (event) => {
        let iconType = event.currentTarget.dataset.iconType;
        this.pushDataLayerIconOnClick(iconType);
      });
    });
  }

  // Header mega menu on open
  pushDataLayerOnOpen(hoverTitle) {
    window.dataLayer.push({
      event: 'headerNavigationOpen',
      pageType: this.pageType,
      hoverObject: hoverTitle,
    });
    debug() && console.log('Header on open: ', window.dataLayer);
  }

  // Header mega menu on close
  pushDataLayerOnClose(hoverTitle) {
    window.dataLayer.push({
      event: 'headerNavigationClosed',
      pageURL: this.pageURL,
      hoverObject: hoverTitle,
    });
    debug() && console.log('Header on close: ', window.dataLayer);
  }

  // Header menu items on click
  pushDataLayerOnClick(navigationTitle, clickTitle) {
    window.dataLayer.push({
      event: 'headerNavigationClick',
      pageType: this.pageType,
      pageURL: this.pageURL,
      navigationTitle: navigationTitle,
      clickTitle: clickTitle,
    });
    debug() && console.log('Header on click: ', window.dataLayer);
  }

  // Header icons on click
  pushDataLayerIconOnClick(iconType) {
    window.dataLayer.push({
      event: 'headerIconClick',
      pageType: this.pageType,
      pageURL: this.pageURL,
      iconType: iconType,
    });
    debug() && console.log('Header on click: ', window.dataLayer);
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();

    this.header = this.closest('[data-header]');

    if (this.header) {
      this.shadow = this.header.querySelector('.header-shadow');
      this.inverse = !!this.header.classList.contains('header--inverse');

      // Extra events
      document.addEventListener('keyup', (event) => {
        this.onKeyUp(event);
      });

      this.shadow?.addEventListener('click', (event) => {
        this.remove(event);
      });
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-is-open')) {
      return;
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
  }

  remove() {
    super.remove();
    this.closeAllSiblings();
  }

  closeAllSiblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest('[data-header]');

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', (event) => {
      this.onKeyUp(event);
    });

    window.addEventListener(
      'resize',
      throttle((event) => {
        if (window.innerWidth < 1024) return;

        document.body.classList.remove('header-is-open');
        document.body.classList.remove('menu-drawer-is-open');
        // Focus on input element if provided
        if (this.options.focusTarget) {
          document.querySelector(this.options.focusTarget)?.focus();
        }
      })
    );

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener('click', () => {
      document.body.classList.remove('header-is-open');
      document.body.classList.remove('menu-drawer-is-open');
      // Focus on input element if provided
      if (this.options.focusTarget) {
        document.querySelector(this.options.focusTarget)?.focus();
      }
    });
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header-search-is-open')) {
      return;
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add('header-search-is-open');
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove('header-search-is-open');
    }
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.headerElement = this;
    this.header = document.querySelector('[data-header]');
    this.stickyNav = document.querySelector('sticky-nav');
    this.headerWrapper = document.querySelector('.shopify-section-group-header-group');
    this.uspBar = document.querySelector('.usp-bar');
    this.headerInverse = !!this.headerElement.classList.contains('header--inverse');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');
    this.productInfo = document.querySelector('[data-product-info]');
    this.menuDrawer = document.querySelector('.menu-drawer');

    // Announcement bar
    this.announcementBar = document.querySelector('.shopify-section.announcement-bar');
    this.announcementBarPosition =
      this.announcementBar?.querySelector('announcement-bar')?.dataset.position;
    this.announcementBarHeight = this.announcementBar?.offsetHeight;
    // document.addEventListener('announcementBarRemoved', this.adjustTopPosition.bind(this));

    if (this.headerWrapper) {
      // Initialize scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      // Initial calculation
      this.calculateHeaderHeight();

      // Adjust top position
      this.adjustOffset();

      // Listen for scroll event
      window.addEventListener(
        'scroll',
        () => {
          clearTimeout(this.timer);
          if (!this.raf) {
            this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
          }
          this.timer = setTimeout(() => {
            cancelAnimationFrame(this.raf);
            this.raf = null;
          }, 50);
        },
        false
      );
    }
  }

  // Function to adjust the offset
  adjustOffset() {
    document.addEventListener('announcementBarRemoved', ({ detail }) => {
      if (this.announcementBar && this.announcementBarPosition === 'sticky') {
        this.announcementBar = null;
        this.scrollOffset -= detail.offsetHeight;
        this.headerStart -= detail.offsetHeight;
        this.header.style.top = `0px`;
      }
    });
  }

  // Function to calculate header height
  calculateHeaderHeight() {
    if (this.announcementBar && this.announcementBarPosition === 'sticky') {
      this.scrollOffset += this.announcementBarHeight;
      this.headerStart += this.announcementBarHeight;

      if (this.stickyNav) {
        this.stickyNav.style.top = `${this.announcementBarHeight}px`;
        this.stickyNav.style.position = 'relative';
      }

      // Adjust the menu drawer top when announcement bar is sticky
      if (this.menuDrawer) {
        this.menuDrawer.style.top = `${this.announcementBarHeight}px`;
      }
    } else if (this.menuDrawer) {
      // Reset the menu drawer top when the announcement bar is not sticky or removed
      this.menuDrawer.style.top = `0px`;
    }

    if (this.announcementBar && this.announcementBarPosition !== 'sticky') {
      this.headerStart += this.announcementBarHeight;
      // Ensure menu drawer top is adjusted even when the announcement bar is not sticky
      if (this.menuDrawer) {
        let currentTop = parseInt(this.menuDrawer.style.top.replace('px', '')) || 0;
        this.menuDrawer.style.top = `${currentTop + this.announcementBarHeight}px`;
      }
    }

    if (this.uspBar) {
      const uspBarHeight = this.uspBar.offsetHeight;
      if (this.announcementBar && this.announcementBarPosition === 'static') {
        this.scrollOffset += uspBarHeight;
      }
      this.headerStart += uspBarHeight;
    }

    if (this.headerElement) {
      this.scrollOffset += this.headerElement.offsetHeight;
    }
  }

  adjustTopPosition() {
    // Assume uspBar and other elements' heights are static or recalculated elsewhere if dynamic
    if (this.uspBar) {
      this.headerStart += this.uspBar.offsetHeight;
    }

    // Apply the new top offset to stickyNav and menuDrawer if they exist
    if (this.stickyNav) {
      this.stickyNav.style.top = `${this.headerStart}px`;
    }
    if (this.menuDrawer) {
      this.menuDrawer.style.top = `${this.headerStart}px`;
    }

    // Adjust the header's top position if needed
    this.header.style.top = `${this.headerStart}px`;
  }

  scrollAnimation() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // only animate if header is closed.
    if (!document.body.classList.contains('header-is-open')) {
      if (scrollTop + window.innerHeight > document.body.clientHeight) {
        this.hide();
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
        this.hide();
      } else if (scrollTop <= this.headerStart) {
        this.revealTop();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    document.body.classList.add('header-hidden', 'header-sticky');
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
    this.productInfoPosition('up');
  }

  reveal() {
    document.body.classList.add('header-sticky');
    document.body.classList.remove('header-hidden');
    let announcementBarNewHeight = this.announcementBar?.offsetHeight;

    if (this.headerInverse) {
      document.body.classList.add('header-inverse-solid');
    }
    this.productInfoPosition('down');

    if (this.announcementBar && this.announcementBarPosition === 'sticky') {
      this.header.style.top = `${announcementBarNewHeight}px`;
    }
  }

  revealTop() {
    if (this.headerInverse && !document.body.classList.contains('header-is-open')) {
      document.body.classList.remove('header-inverse-solid');
    }
    document.body.classList.remove('header-hidden', 'header-sticky');
    this.productInfoPosition('up');
    if (this.announcementBarPosition === 'sticky') {
      this.header.style.top = `0px`;
    }
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if (!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }

  productInfoPosition(pos = 'up') {
    if (!this.productInfo) {
      return;
    }
    if (pos == 'down') {
      this.productInfo.classList.replace('top-0', 'top-[4.5rem]');
    } else {
      this.productInfo.classList.replace('top-[4.5rem]', 'top-0');
    }
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
